<template>
 <v-container grid-list-md>
      <v-layout row wrap justify-center ml-3>
          <v-flex
                  d-flex
                  xs12
                  sm12
                  md12
                  mt-3
                  
                >
                <div class="headline">
                Generate Token
                </div>
                
          </v-flex>
           <v-flex d-flex xs12 sm12 md12>
            <div class="subheading">Enter token properties below to generate a JWT token for use with API</div>
           </v-flex>
        <v-flex d-flex xs12 sm6 md6>
          <!-- <v-layout row wrap> -->
 
            <!-- <v-flex d-flex> -->
              <v-layout row wrap >
                <v-flex
                  d-flex
                  xs12
                   style="min-width:450px"
                >
                  <v-select
                    :items="apiClients"
                    item-text="name"
                    v-model="selectedClient"
                    :loading="isLoading"
                    return-object
                    menu-props="auto"
                    label="Choose Api Client"
                    no-data-text="No API clients available"
                    hide-details
                    single-line
                    @change="handleSelect">
                  </v-select>
                </v-flex>

                <v-flex
                  d-flex
                  xs12
                >
                  <v-text-field
                    v-model="clientID"
                    label="Client ID"
                    @keyup="handleTextInput">
                  </v-text-field>   
                </v-flex>

                <v-flex
                  d-flex
                  xs12
                >
                  <v-text-field
                    v-model="clientSecret"
                    label="Client Secret"
                    @keyup="handleTextInput">
                  </v-text-field>
                </v-flex>

                <v-flex
                  d-flex
                  xs12
                >
                  <v-card class="mt-2">
                    <v-toolbar color="grey lighten-4">
                      <div class="subheading text-uppercase">Header: Algorithm & Token Type</div>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <editor 
                      height="100"
                      v-model="headerText" 
                      @init="editorInit" 
                      lang="json" 
                      theme="chrome" 
                    >
                    </editor>
                  </v-card>  
                </v-flex>

                <v-flex
                  d-flex
                  xs12
                >
                  <v-card class="mt-3">
                    <v-toolbar color="grey lighten-4">
                      <div class="subheading text-uppercase">Payload</div>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <editor      
                      height="200"
                      v-model="payloadText" 
                      @init="editorInit" 
                      lang="json" 
                      theme="chrome" 
                    >
                    </editor>
                  </v-card>  
                </v-flex>

              </v-layout>
            <!-- </v-flex> -->
          <!-- </v-layout> -->
        </v-flex>
        <v-flex d-flex xs12 sm6 md6>
           <v-card class="ma-3">
              <v-toolbar color="deep-orange darken-1">
                <span class="subheading text-uppercase white--text">Token</span>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-textarea
                ref="text"
                v-model="token"
                box
                readonly
                no-resize
                append-icon="save"
                @click:append="copyTextArea"
                :success-messages="successMessagesToken"
                color="green"
                rows="17">
              </v-textarea>
            </v-card>  
        </v-flex>
        
        
       
      </v-layout>
    </v-container>
 
</template>

<script>
import ApiClient from "./ApiClient";
import { createJWT } from "../auth/helpers";
import uuidv1 from "uuid/v1";

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

const tokenDefaultTTL = 24 * 60 * 60;
const now = Math.floor(Date.now() / 1000);
const exp = now + tokenDefaultTTL;
const sessionID = uuidv1();

const SCHEMA = {
  header: {
    alg: "HS256",
    typ: "JWT"
  },
  payload: {
    aci: null,
    jti: sessionID,
    iat: now,
    exp: exp,
    scopes: []
  }
};

export default {
  name: "generate-token",
  components: { ApiClient, editor: require("vue2-ace-editor") },
  props: ["auth", "authenticated"],
  data() {
    return {
      isLoading: true,
      apiClients: [],
      clientID: null,
      clientSecret: null,
      selectedClient: null,
      errorMessagesHeader: [],
      errorMessagesPayload: [],
      successMessagesToken: [],
      schema: SCHEMA,
      headerText: this.formatJSON(SCHEMA.header),
      payloadText: this.formatJSON(SCHEMA.payload),
      token: null
    };
  },

  created: function() {
    if (this.authenticated) {
      this.$http.get(`${API_ENDPOINT}/apiClient`).then(
        response => {
          this.apiClients = response.body.data;
          this.isLoading = false;
        },
        error => {
          console.error(`Error while retrieving object: ${error.statusText}`);
          this.isLoading = false;
        }
      );
    }
  },
  watch: {
    token: function() {
      this.successMessagesToken = [];
    },
    payloadText: function(newpayloadText) {
      try {
        this.schema.payload = JSON.parse(newpayloadText);
        this.clientID = this.schema.payload.aci;
        this.errorMessagesPayload = [];
        this.computeToken();
      } catch (e) {
        this.errorMessagesPayload = ["Invalid JSON object"];
        this.token = null;
      }
    },
    headerText: function(newHeaderText) {
      try {
        this.schema.header = JSON.parse(newHeaderText);
        this.errorMessagesHeader = [];
        this.computeToken();
      } catch (e) {
        this.errorMessagesHeader = ["Invalid JSON object"];
        this.token = null;
      }
    }
  },
  methods: {
    editorInit: function() {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/json"); //language
      require("brace/theme/chrome");
    },
    isLoggedIn() {
      return this.authenticated;
    },
    formatJSON: function(value) {
      return JSON.stringify(value, null, 4);
    },
    handleTextInput() {
      // Clear drop-down selection
      if (this.selectedClient) {
        this.selectedClient = null;
      }

      // Set the clientID
      this.schema.payload.aci = this.clientID ? this.clientID : null;
      // Format and display the payload
      this.payloadText = this.formatJSON(this.schema.payload);

      this.computeToken();
    },
    handleSelect() {
      // Set the new values from the drop-down selection
      if (this.selectedClient) {
        this.clientID = this.selectedClient.clientId;
        this.clientSecret = this.selectedClient.clientSecret;
      }
      // Set the clientID
      this.schema.payload.aci = this.clientID;
      // Format and display the payload
      this.payloadText = this.formatJSON(this.schema.payload);

      this.computeToken();
    },
    computeToken() {
      if (this.clientID && this.clientSecret) {
        // Generate a token
        this.token = createJWT(
          this.headerText,
          this.payloadText,
          this.clientSecret
        );
      } else {
        // Clear token
        this.token = null;
      }
    },
    copyTextArea() {
      this.$copyText(this.token).then(
        () => {
          this.successMessagesToken = ["Copied to clipboard"];
        },
        error => {
          console.error(`Could not copy to clipboard: ${error}`);
        }
      );
    }
  }
};
</script>

<style>
.token-container.token-container {
  padding: 2rem !important;
}
.page {
  width: 100%;
}

.content {
  width: 100%;
  max-width: none !important;
}
</style>
